module.exports = __webpack_public_path__ + "img/en_tis7.340e9f14.png";